module.exports = { id: "map", url: "/build/app/img/symbols.svg#map", viewBox: "", toString: function() { return this.url; } };